import {
  base_colorAction,
  text_colorTextPrimary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import {
  font_family_weight_medium,
  font_md,
  font_xs,
  fontH2,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export const workspace = css`
  margin: 0 auto;
  max-width: ${spacing(240)};
  width: 100%;

  .pageHeader {
    align-items: flex-start;
    display: flex;
    gap: ${spacing(4)};
    justify-content: space-between;
    margin-bottom: ${spacing(6)};

    p,
    h1 {
      margin: 0;
    }

    .eyebrow {
      color: ${base_colorAction};
      font-family: ${font_family_weight_medium};
      ${font_xs};
      margin-bottom: ${spacing(3)};
    }

    h1 {
      color: ${text_colorTextPrimary};
      ${fontH2};
      margin-bottom: ${spacing(2)};
    }

    .subtitle {
      color: ${text_colorTextSecondary};
      ${font_md};
    }
  }
`
